import { isBoolean, isNumber } from 'lodash/lang';

export function isFieldEmpty(fieldValue) {
  return !fieldValue && !isBoolean(fieldValue) && !isNumber(fieldValue);
}

export function isNumberFieldEmpty(fieldValue) {
  return !fieldValue;
}
